/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { AlertService } from '@shared/services/alert/alert.service';
import { HotelService } from './hotel.service';
import { RequestState, RequestStatus } from '@shared/models/request-state';
import { ReservationResponse } from './models/response/reservation.response';
import { HotelResponse } from './models/response/hotel.response';
import { DateTime } from 'luxon';
import { SequenceStore } from '@sequence/sequence.store';

@Injectable({
  providedIn: 'root',
})
export class HotelStore {
  constructor(
    private hotelService: HotelService,
    private sequenceStore: SequenceStore,
    private alertService: AlertService,
  ) {}

  getHotel(
    dutyPeriodIndex: number,
    isRefresh = false,
  ): Observable<RequestState<ReservationResponse>> {
    const hotelRequest = this.sequenceStore.getHotelRequest();

    if (hotelRequest) {
      return this.hotelService.getHotel(hotelRequest, isRefresh).pipe(
        tap((requestState) => console.log(requestState)),
        map((requestState) => {
          return this.mapResponse(requestState, dutyPeriodIndex);
        }),
      );
    }

    return of(
      new RequestState<ReservationResponse>(RequestStatus.IsCompleteNoResponse),
    );
  }

  private mapResponse(
    requestState: RequestState<HotelResponse>,
    dutyPeriodIndex: number,
  ): RequestState<ReservationResponse> {
    if (requestState.hasError) {
      this.showErrorALert();
    }

    if (!requestState.response) {
      return requestState.into<ReservationResponse>();
    }

    // Find the hotel for the duty period requested.
    for (const reservation of requestState.response!.reservations) {
      if (reservation.flight.dutyPeriodId === dutyPeriodIndex) {
        // Some pickup locations contain html, wrap in div tags to display properly.
        if (reservation.hotel?.pickupLocation) {
          reservation.hotel.pickupLocation = this.wrapPickupLocationInDiv(
            reservation.hotel.pickupLocation,
          );
        }

        reservation.timestamp = DateTime.fromISO(
          requestState.response.timestamp,
          { zone: 'utc' },
        );

        return requestState.into<ReservationResponse>(reservation);
      }
    }

    // Hotel not found.
    return requestState.into<ReservationResponse>();
  }

  /** Attempt at fixing formatting when random pickup location info is HTML. */
  private wrapPickupLocationInDiv(text: string): string {
    // const unescaped =
    //   new DOMParser().parseFromString(text, 'text/html').documentElement
    //     .textContent || '';
    // return `<div>${unescaped}</div>`;
    return text;
  }

  private showErrorALert(): void {
    this.alertService.setAlert({
      type: 'error',
      message: 'Unable to load hotel information',
    });
  }
}
